import React, { useState } from 'react';
import type { AddMemberSelectProps } from './AddMemberSelect';
import AddMemberSelect from './AddMemberSelect';
import Button from '../components/Button';
import Tooltip from '../components/Tooltip';
import type { DocumentType } from '../graphql/generated/gql';
import { gql } from '../graphql/generated/gql';

const ADD_MEMBER_CONTROL_FRAGMENT = gql(`
  fragment AddMemberControl_group on Group {
    ...AddMemberSelect_group
  }
`);

type AddMemberControlProps = {
  group: DocumentType<typeof ADD_MEMBER_CONTROL_FRAGMENT>;
  canEdit: boolean;
} & Pick<AddMemberSelectProps, 'onAddGroup' | 'onAddUser'>;

const AddMemberControl = ({
  group,
  canEdit,
  onAddGroup,
  onAddUser,
}: AddMemberControlProps) => {
  const [isAdding, setIsAdding] = useState(false);

  return isAdding ? (
    <AddMemberSelect
      group={group}
      onDismiss={() => setIsAdding(false)}
      onAddGroup={onAddGroup}
      onAddUser={onAddUser}
    />
  ) : (
    <Tooltip
      content={
        canEdit ? undefined : 'Only group owners\ncan add members\ndirectly'
      }
      enabledForSmallSize
    >
      <Button
        disabled={!canEdit}
        onClick={() => setIsAdding(true)}
        variant="secondary"
      >
        Add member
      </Button>
    </Tooltip>
  );
};

export default AddMemberControl;
